<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">总课程列表</span>
                <el-row class="grid-content">
                  <el-col class="text-right">
                    <el-button type="primary" size="small" :loading="loadingGenerateTemplate" @click="onDownloadTemplateClick">
                      生成模板
                    </el-button>
                    <el-button type="primary" size="small" @click="onImportDataClick">
                      导入数据
                    </el-button>
                    <el-button type="primary" icon="el-icon-plus" size="small" @click="addSpeedupCourse">
                      添加课程
                    </el-button>
                    <el-button type="primary" :disabled="selectedCourses.length==0" size="small" @click="batchSetCourseList('minute')">
                      设置课程时长
                    </el-button>
                    <el-button type="primary" :disabled="selectedCourses.length==0" size="small" @click="batchSetCourseList('university')">
                      设置所属大学
                    </el-button>
                    <el-button type="primary" :disabled="selectedCourses.length==0" size="small" @click="batchSetCourseList('campus')">
                      设置所属校区
                    </el-button>
                    <el-button type="primary" :disabled="selectedCourses.length==0" size="small" @click="batchSetCourseList('contract')">
                      设置合同
                    </el-button>
                    <el-button type="danger" :disabled="selectedCourses.length==0" size="small" @click="deleteSelectedCourse">
                      删除所选课程
                    </el-button>

                  </el-col>
                </el-row>
                <el-row class="grid-content">
                  <el-col class="text-right">
                    <el-select placeholder="大学" v-model="selectedYearCourseType" @change="onSearchConditionChanged" size="medium" class="margin-left-10">
                      <el-option v-for="item in yearCourseTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                    <el-input placeholder="搜索课程" size="medium" clearable suffix-icon="el-icon-search" class="margin-left-10 search-InputBox"
                      v-model="searchCondition.Name" @change="onSearchConditionChanged">
                    </el-input>
                  </el-col>
                </el-row>
                <el-tabs v-model="activeUniversityGroup" type="card" @tab-add="handleTabAdd">
                  <el-tab-pane :key="item.IdValue" v-for="item in universityGroups" :name="item.GroupNumber.toString()">
                    <span slot="label" @dblclick="handleTabEdit(activeUniversityGroup)"> {{item.NameValue}} </span>
                  </el-tab-pane>
                </el-tabs>
                <el-row class="grid-content cs-courseList-container">
                  <el-col>
                    <el-table ref="speedupCourseTable" v-loading="loading" :data="speedupCourseList" :height="580" :cell-class-name="cellStyle"
                      :default-sort="{prop: 'Name', order: 'ascending'}" @cell-dblclick="onCellDbClicked" :header-row-class-name="'el-table-header'"
                      @selection-change="handleSelectionChange">
                      <el-table-column type="selection" width="45"></el-table-column>
                      <el-table-column prop="Name" label="课程" sortable width="200" fixed>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{scope.row.Name}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-input v-model="editingCourseName" maxlength="250" size="small" :placeholder="scope.row.Name">
                            </el-input>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="CourseCode" label="课程编码" width="160" sortable fixed>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{scope.row.CourseCode}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-input v-model="editingCourseCode" maxlength="50" size="small" :placeholder="scope.row.CourseCode">
                            </el-input>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="ProfessorName" label="教授" sortable width="160">
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{scope.row.ProfessorName}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-input v-model="editingProfessorName" maxlength="250" size="small" :placeholder="scope.row.ProfessorName">
                            </el-input>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="CourseMinutes" label="课程时长(分钟)" width="160" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{scope.row.CourseMinutes}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-input-number v-model="editingCourseMinutes" :min="30" :max="600" :step="30" size="small">
                            </el-input-number>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="IsFreeVideo" label="视频免费" width="100" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{scope.row.IsFreeVideo ? "免费" : "收费"}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-checkbox v-model="editingIsFreeVideo" maxlength="50" size="small">视频免费</el-checkbox>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="所属大学" width="120" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{getUniversityName(scope.row)}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-select v-model="editingCourseUniversityList" multiple placeholder="请选择大学" size="small">
                              <el-option v-for="item in getUniversityListByGroup(scope.row.UniversityGroup)" :key="item.Id" :label="item.Abbreviation"
                                :value="item.Id">
                              </el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="IsCheckCamera" label="是否检测摄像头" width="100" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{scope.row.IsCheckCamera ? "是" : "否"}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-checkbox v-model="editingIsCheckCamera" maxlength="50" size="small">检测摄像头</el-checkbox>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="IsYearCourse" label="年课" width="120" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{scope.row.IsYearCourse ? "年课 " + scope.row.StartMonth + "月 - " + scope.row.EndMonth + "月" : "非年课"}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <div>
                              <el-checkbox v-model="editingIsYearCourse" size="small">是否年课</el-checkbox>
                            </div>
                            <div>
                              开始月:<el-input-number v-model="editingStartMonth" :min="1" :max="12" :step="1" size="mini">
                              </el-input-number>
                            </div>
                            <div>
                              结束月:<el-input-number v-model="editingEndMonth" :min="1" :max="12" :step="1" size="mini">
                              </el-input-number>
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="合同" width="120" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{getContractName(scope.row)}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-select v-model="editingContractId" placeholder="请选择合同" size="small">
                              <el-option v-for="item in contractList" :key="item.Value" :label="item.Text" :value="item.Value">
                              </el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="课程类型" width="120" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{GLOBAL.enumCourseBasicCategory.getDesc(scope.row.CourseBasicCategory)}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-select v-model="editingCourseBasicCategory" placeholder="请选择课程类型" size="small">
                              <el-option v-for="item in GLOBAL.enumCourseBasicCategory.getOptions()" :key="item.value" :label="item.desc" :value="item.value">
                              </el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="课程年级" width="120" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{GLOBAL.enumCourseClassGrade.getDesc(scope.row.CourseClassGrade)}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-select v-model="editingCourseClassGrade" placeholder="请选择课程年级" size="small">
                              <el-option v-for="item in GLOBAL.enumCourseClassGrade.getOptions()" :key="item.value" :label="item.desc" :value="item.value">
                              </el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="课程形式" width="120" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{GLOBAL.enumNormalCourseCategory.getDesc(scope.row.CourseCategory)}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-select v-model="editingCourseCategory" placeholder="请选择课程形式" size="small">
                              <el-option v-for="item in courseCategoryList" :key="item.value" :label="item.desc" :value="item.value">
                              </el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="所属校区" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{getCampusName(scope.row)}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-select v-model="editingCourseCampusList" multiple placeholder="请选择校区" size="small">
                              <el-option v-for="item in campusList" :key="item.Id" :label="item.Name" :value="item.Id">
                              </el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="HasOwnDevice" label="自带电脑" width="110" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{scope.row.HasOwnDevice ? "是" : "否"}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-checkbox v-model="editingHasOwnDevice" maxlength="50" size="small">可自带电脑</el-checkbox>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="上课形式与回放规则须知" width="120" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{getCourseReplayRuleName(scope.row)}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-select v-model="editingCourseReplayRuleId" placeholder="请选择上课形式与回放规则须知" size="small">
                              <el-option v-for="item in courseReplayRuleList" :key="item.Value" :label="item.Text" :value="item.Value">
                              </el-option>
                            </el-select>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="VideoAppointmentAll" label="预约无视频课节" width="120" sortable>
                        <template slot-scope="scope">
                          <div v-if="scope.row.Id != editingRowId">
                            <span>{{scope.row.VideoAppointmentAll ? "是" : "否"}}</span>
                          </div>
                          <div v-if="scope.row.Id == editingRowId">
                            <el-checkbox class="cs-courseList-videoAppointmentAll" v-model="editingVideoAppointmentAll" maxlength="50"
                              size="small">可预约无视频课节</el-checkbox>
                            <el-button icon="el-icon-success" class="margin-left-10" size="small" type="text" :disabled="disabledSave"
                              @click="saveCourse(scope.row)"></el-button>
                            <el-button icon="el-icon-error" class="margin-left-10 gray" size="small" type="text" @click="cancelEdit(scope.row)"></el-button>
                            <el-alert v-show="editingMessage != ''" :title="editingMessage" class="error-message" type="error" :closable="false"> </el-alert>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="大学信息" :center="true" :close-on-click-modal="false" width="750px" v-on:close="onCloseUniversityGroupEditor"
      :visible.sync="displayUniversityEditor" top="5vh">
      <university-group-editor ref="universityGroupEditor" v-on:closeUniversityGroupEditor="onCloseUniversityGroupEditor"
        :universityList="editingUniversityList" :university-group="editingUniversityGroup" v-on:saveSuccess="onSaveUniversitySuccess"></university-group-editor>
    </el-dialog>
    <el-dialog :title="batchSetTitle" :center="true" :close-on-click-modal="false" width="650px" v-on:close="onBatchCloseCourseListEditor"
      :visible.sync="displayBatchCourseListEditor" top="5vh">
      <batch-course-list-editor ref="batchCourseListEditor" v-on:closeBatchCloseCourseListEditor="onBatchCloseCourseListEditor"
        :selectedCourses="selectedCourses" :batchSetType="batchSetType" :universityList="editingUniversityList" :campusList="campusList"
        :contractList="contractList" v-on:saveBatchCourseListSuccess="onSaveBatchCourseListSuccess"></batch-course-list-editor>
    </el-dialog>
    <el-dialog center title="上传文件" :show-close="fileUploaderCloseVisible" :close-on-click-modal="false" width="700px" :visible.sync="fileUploaderVisible"
      top="8vh">
      <file-uploader v-on:closeEditor="onCloseEditor" v-on:fileUploaded="onFileUploaded" @fileBeforeUpload="onFileBeforeUpload"
        @fileUploadError="onFileUploadError" :submitBtnText="'确认导入'" :isVisible="fileUploaderVisible" :limit="1"
        :accepts="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" :tips="'只能上传格式为.xlsx的文件'" :type="{type:'SpeedupCourse'}"
        :supportedFile="'.xlsx'"></file-uploader>
    </el-dialog>
  </div>
</template>

<style lang="scss">
.cs-contentContainer {
  .cs-courseList-container {
    .el-checkbox {
      margin: auto;
    }
  }
}
.el-notification {
  width: 60%;
}
</style>

<style lang="scss" scoped>
/* elementui 的tabs组件出现蓝色边框问题 */

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.cs-contentContainer {
  .grid-content {
    margin-bottom: 10px;

    .cs-schedule-buttonContainer {
      text-align: right;
    }
  }

  .gray {
    color: gray;
  }

  .margin-left-10 {
    margin-left: 10px;
  }

  .search-InputBox {
    width: 200px;
  }

  .error-message {
    width: 300px;
    height: 20px;
  }

  .el-input-number {
    width: 100px;
  }

  .cs-courseList-videoAppointmentAll {
    white-space: break-spaces;
    display: flex;
  }
}
</style>

<script>
import { downloadFile } from "@/config/mUtils";
import {
  getUniversityGroups,
  getUniversityByGroup,
  getUniversityList,
  getCampusList,
} from "../../service/common.service";
import { getContractList } from "@/service/contract.service";
import {
  downloadTemplate,
  getSpeedupCourseList,
  saveSpeedupCourseList,
  disableSpeedupCourse,
} from "../../service/speedupCourse.service";
import navigator from "../../components/navigator";
import universityGroupEditor from "../../components/universityGroupEditor.vue";
import batchCourseListEditor from "../../components/batchCourseListEditor.vue";
export default {
  data() {
    return {
      loading: false,
      loadingGenerateTemplate: false,
      activeUniversityGroup: "1",
      universityGroups: [],
      universityList: [],
      campusList: [],
      contractList: [],
      courseReplayRuleList: [],
      searchCondition: {
        Name: "",
      },
      editingRowId: -1,
      disabledSave: false,
      editingCourseName: "",
      orginalCourseName: "",
      editingMessage: "",
      speedupCourseList: [],
      selectedCourses: [],
      displayUniversityEditor: false,
      batchSetType: "",
      batchSetTitle: "",
      displayBatchCourseListEditor: false,
      editingUniversityList: [],
      editingUniversityGroup: "0",
      editingCourseCode: "",
      orginalCourseCode: "",
      editingProfessorName: "",
      orginalProfessorName: "",
      editingIsFreeVideo: false,
      editingIsCheckCamera: false,
      editingHasOwnDevice: true,
      editingVideoAppointmentAll: false,
      editingCourseMinutes: 0,
      editingCourseUniversityList: [],
      originalCourseUniversityList: [],
      editingCourseCampusList: [],
      editingIsYearCourse: false,
      editingStartMonth: 0,
      editingEndMonth: 0,
      editingContractId: null,
      editingCourseReplayRuleId: null,
      editingCourseBasicCategory: null,
      editingCourseCategory: null,
      editingCourseClassGrade: null,
      fileUploaderVisible: false,
      fileUploaderCloseVisible: true,
      selectedYearCourseType: 0,
      yearCourseTypeList: [
        { key: 0, value: "所有" },
        { key: 1, value: "年课" },
        { key: 2, value: "非年课" },
      ],
      courseCategoryList: [],
    };
  },
  components: {
    navigator,
    universityGroupEditor,
    batchCourseListEditor,
    fileUploader: () => import("@/components/fileHandler/fileUploader"),
  },
  computed: {},
  async created() {
    this.courseCategoryList = this.GLOBAL.enumNormalCourseCategory
      .getOptions()
      .filter((i) => i.value != 1);
    getUniversityList().then((result) => {
      if (!!result && result.success) {
        this.universityList = result.data;
      }
    });
    getCampusList().then((result) => {
      if (!!result && result.success) {
        this.campusList = result.data;
      }
    });
    getContractList(this.GLOBAL.contractType.universityCourse).then(
      (result) => {
        if (!!result && result.success) {
          this.contractList = result.data;
        }
      }
    );
    getContractList(this.GLOBAL.contractType.courseReplayRule).then(
      (result) => {
        if (!!result && result.success) {
          this.courseReplayRuleList = result.data;
        }
      }
    );
    await this.loadUniversityGroups();
    if (!!this.universityGroups && this.universityGroups.length > 0) {
      this.activeUniversityGroup =
        this.universityGroups[0].GroupNumber.toString();
    }
    this.loadSpeedupCourseList();
  },
  methods: {
    getUniversityName(row) {
      if (!!row.UniversityList && row.UniversityList.length > 0) {
        let name = this.universityList
          .filter(
            (i) => !!row.UniversityList && row.UniversityList.indexOf(i.Id) >= 0
          )
          .map((i) => i.Abbreviation)
          .join(", ");
        return name;
      }
      return "";
    },
    getCampusName(row) {
      if (!!row.CampusList && row.CampusList.length > 0) {
        let names = this.campusList
          .filter((i) => !!row.CampusList && row.CampusList.indexOf(i.Id) >= 0)
          .map((i) => i.Name)
          .join(",");

        return names;
      }
      return "";
    },
    getUniversityListByGroup(group) {
      return this.universityList.filter((i) => i.GroupNumber == group);
    },
    getContractName(row) {
      if (!row.ContractId) return "";

      let contract = this.contractList.find(
        (item) => item.Value === row.ContractId
      );
      if (!contract) {
        return "";
      }

      return contract.Text;
    },
    getCourseReplayRuleName(row) {
      if (!row.CourseReplayRuleId) return "";

      let contract = this.courseReplayRuleList.find(
        (item) => item.Value === row.CourseReplayRuleId
      );
      if (!contract) {
        return "";
      }

      return contract.Text;
    },
    async loadUniversityGroups() {
      let result = await getUniversityGroups();

      if (!!result && result.success) {
        this.universityGroups = result.data.filter(
          (i) => i.NameValue != "无学校"
        );
      }
    },
    handleTabAdd() {
      this.displayUniversityEditor = true;
      this.editingUniversityList = [];
      this.editingCourseCampusList = [];
      this.editingUniversityGroup = -1;
      this.editingContractId = null;
      this.editingCourseReplayRuleId = null;
      this.editingCourseBasicCategory = null;
      this.editingCourseCategory = null;
      this.editingCourseClassGrade = null;
    },
    handleTabEdit(universityGroup) {
      this.editingUniversityGroup = universityGroup;
      getUniversityByGroup(universityGroup).then((result) => {
        if (!!result && result.success) {
          this.editingUniversityList = result.data;
          this.displayUniversityEditor = true;
        }
      });
    },
    onCloseUniversityGroupEditor() {
      this.displayUniversityEditor = false;
      this.$refs.universityGroupEditor.reset();
    },
    onSearchConditionChanged() {
      this.loadSpeedupCourseList();
    },
    onSaveUniversitySuccess() {
      this.loadUniversityGroups();
      this.loadSpeedupCourseList();
      this.displayUniversityEditor = false;
    },
    onBatchCloseCourseListEditor() {
      this.displayBatchCourseListEditor = false;
      this.$refs.batchCourseListEditor.reset();
    },
    onSaveBatchCourseListSuccess() {
      this.loadUniversityGroups();
      this.loadSpeedupCourseList();
      this.displayBatchCourseListEditor = false;
    },
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    onDownloadTemplateClick() {
      this.loadingGenerateTemplate = true;
      downloadTemplate()
        .then((result) => {
          downloadFile(result);

          this.loadingGenerateTemplate = false;
        })
        .catch((err) => {
          this.loadingGenerateTemplate = false;
        });
    },
    onImportDataClick() {
      this.fileUploaderVisible = true;
    },
    onCloseEditor() {
      this.fileUploaderVisible = false;
      this.fileUploaderCloseVisible = true;
    },
    onFileBeforeUpload() {
      this.fileUploaderCloseVisible = false;
    },
    onFileUploadError() {
      this.fileUploaderCloseVisible = true;

      this.$message.error("导入数据失败。");
    },
    onFileUploaded() {
      this.fileUploaderVisible = false;
      this.fileUploaderCloseVisible = true;

      this.$message.success("导入数据成功。");
      this.loadSpeedupCourseList();
    },
    addSpeedupCourse() {
      this.$refs.speedupCourseTable.clearSort();
      if (this.editingRowId == 0) return;
      this.editingCourseName = "";
      this.editingCourseCode = "";
      this.editingProfessorName = "";
      this.editingCourseMinutes = 180;
      this.editingCourseUniversityList = [];
      this.editingCourseCampusList = [];
      this.editingIsFreeVideo = false;
      this.editingIsCheckCamera = false;
      this.editingHasOwnDevice = true;
      this.editingVideoAppointmentAll = false;
      this.editingIsYearCourse = false;
      this.editingStartMonth = 9;
      this.editingEndMonth = 4;
      this.editingContractId = null;
      this.editingCourseReplayRuleId = null;
      this.editingCourseBasicCategory = null;
      this.editingCourseCategory = null;
      this.editingCourseClassGrade = null;
      let newRow = {
        Id: 0,
        Name: "",
        UniversityGroup: this.activeUniversityGroup,
        CourseCode: "",
        ProfessorName: "",
        CourseMinutes: 180,
        IsFreeVideo: false,
        IsCheckCamera: false,
        HasOwnDevice: true,
        VideoAppointmentAll: false,
        UniversityList: [],
        CampusList: [],
        ContractId: null,
        CourseBasicCategory: null,
        CourseCategory: null,
        CourseClassGrade: null,
        Enable: true,
      };
      this.speedupCourseList.unshift(newRow);
      this.editingRowId = 0;
    },
    batchSetCourseList(type) {
      this.batchSetType = type;
      switch (type) {
        case "minute":
          this.batchSetTitle = "批量设置课程时长";
          break;
        case "university":
          this.batchSetTitle = "批量设置所属大学";
          break;
        case "campus":
          this.batchSetTitle = "批量设置所属校区";
          break;
        case "contract":
          this.batchSetTitle = "批量设置合同";
          break;
      }
      this.editingUniversityList = this.getUniversityListByGroup(
        this.activeUniversityGroup
      );
      this.displayBatchCourseListEditor = true;
    },
    batchSetCampus() {
      this.displayCampusEditor = true;
    },
    loadSpeedupCourseList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      getSpeedupCourseList(
        this.activeUniversityGroup,
        this.searchCondition.Name,
        this.selectedYearCourseType
      ).then((result) => {
        if (!!result && result.success) {
          this.speedupCourseList = result.data;
        }
        this.editingRowId = -1;
        this.loading = false;
      });
    },
    onCellDbClicked(row, column, cell, event) {
      if (this.editingRowId == row.Id) {
        return;
      }
      if (this.editingRowId == 0) {
        this.editingMessage = "请先保存或删除新增行";
        return;
      }
      if (
        column.label == "课程" ||
        column.label == "课程编码" ||
        column.label == "课程时长(分钟)" ||
        column.label == "所属大学" ||
        column.label == "所属校区" ||
        column.label == "视频免费" ||
        column.label == "是否检测摄像头" ||
        column.label == "年课" ||
        column.label == "合同" ||
        column.label == "课程类型" ||
        column.label == "课程年级" ||
        column.label == "课程形式" ||
        column.label == "自带电脑" ||
        column.label == "预约无视频课节" ||
        column.label == "上课形式与回放规则须知"
      ) {
        this.editingRowId = row.Id;
        this.orginalCourseName = row.Name;
        this.editingCourseName = row.Name;
        this.editingCourseCode = row.CourseCode;
        this.orginalCourseCode = row.CourseCode;
        this.editingProfessorName = row.ProfessorName;
        this.orginalProfessorName = row.ProfessorName;
        this.editingCourseMinutes = row.CourseMinutes;
        this.editingCourseUniversityList = row.UniversityList;
        this.originalCourseUniversityList = row.UniversityList;
        this.editingCourseCampusList = row.CampusList;
        this.editingIsFreeVideo = row.IsFreeVideo;
        this.editingIsCheckCamera = row.IsCheckCamera;
        this.editingHasOwnDevice = row.HasOwnDevice;
        this.editingVideoAppointmentAll = row.VideoAppointmentAll;
        this.editingIsYearCourse = row.IsYearCourse;
        this.editingStartMonth = row.StartMonth;
        this.editingEndMonth = row.EndMonth;
        this.editingContractId = row.ContractId;
        this.editingCourseReplayRuleId = row.CourseReplayRuleId;
        this.editingCourseBasicCategory = row.CourseBasicCategory;
        this.editingCourseCategory = row.CourseCategory;
        this.editingCourseClassGrade = row.CourseClassGrade;
      }
    },
    saveCourse(row) {
      this.disabledSave = true;
      this.editingMessage = "";
      row.Name = this.editingCourseName;
      row.CourseCode = this.editingCourseCode;
      row.ProfessorName = this.editingProfessorName;
      row.CourseMinutes = this.editingCourseMinutes;
      row.UniversityList = this.editingCourseUniversityList;
      row.CampusList = this.editingCourseCampusList;
      row.IsFreeVideo = this.editingIsFreeVideo;
      row.IsCheckCamera = this.editingIsCheckCamera;
      row.HasOwnDevice = this.editingHasOwnDevice;
      row.VideoAppointmentAll = this.editingVideoAppointmentAll;
      row.IsYearCourse = this.editingIsYearCourse;
      row.StartMonth = this.editingStartMonth;
      row.EndMonth = this.editingEndMonth;
      row.ContractId = this.editingContractId;
      row.CourseReplayRuleId = this.editingCourseReplayRuleId;
      row.CourseBasicCategory = this.editingCourseBasicCategory;
      row.CourseCategory = this.editingCourseCategory;
      row.CourseClassGrade = this.editingCourseClassGrade;
      if (row.Name == "") {
        this.editingMessage = "课程名称不能为空";
        this.disabledSave = false;
        return;
      }
      if (row.CourseCode == "") {
        this.editingMessage = "课程编码不能为空";
        this.disabledSave = false;
        return;
      }
      if (row.CourseCode.indexOf(" ") >= 0) {
        this.editingMessage = "课程编码中不能含有空格";
        this.disabledSave = false;
        return;
      }

      if (row.IsYearCourse) {
        if (row.StartMonth == 0 || row.StartMonth > 12) {
          this.editingMessage = "年课开始月份错误";
          return;
        }

        if (row.EndMonth == 0 || row.EndMonth > 12) {
          this.editingMessage = "年课结束月份错误";
          return;
        }
      }

      saveSpeedupCourseList(
        row.Id,
        row.Name,
        this.activeUniversityGroup,
        row.CourseCode,
        row.ProfessorName,
        row.CourseMinutes,
        row.UniversityList,
        row.CampusList,
        row.IsFreeVideo,
        row.IsCheckCamera,
        row.IsYearCourse,
        row.StartMonth,
        row.EndMonth,
        row.ContractId,
        row.CourseBasicCategory,
        row.CourseClassGrade,
        row.CourseCategory,
        row.HasOwnDevice,
        row.VideoAppointmentAll,
        row.CourseReplayRuleId
      ).then((result) => {
        if (!!result && result.success) {
          this.editingRowId = -1;
          this.orginalCourseName = "";
          this.orginalCourseCode = "";
          this.orginalProfessorName = "";
          this.editingMessage = "";
          row.Id = result.data;
          this.$message.success("保存成功");
        } else {
          this.editingMessage = result.message;
        }
        this.disabledSave = false;
      });
    },
    cancelEdit(row) {
      this.editingRowId = -1;
      row.Name = this.orginalCourseName;
      row.CourseCode = this.orginalCourseCode;
      row.ProfessorName = this.orginalProfessorName;
      this.orginalCourseName = "";
      this.editingMessage = "";
      this.editingCourseName = "";
      this.orginalCourseCode = "";
      this.editingCourseCode = "";
      this.orginalProfessorName = "";
      this.editingProfessorName = "";
      this.editingCourseMinutes = 0;
      this.editingIsFreeVideo = false;
      this.editingIsCheckCamera = false;
      this.editingHasOwnDevice = true;
      this.editingVideoAppointmentAll = true;
      this.editingIsYearCourse = false;
      this.editingStartMonth = 9;
      this.editingEndMonth = 4;
      this.editingCourseUniversityList = [];
      this.originalCourseUniversityList = [];
      this.editingCourseCampusList = [];
      this.editingContractId = null;
      this.editingCourseReplayRuleId = null;
      this.editingCourseBasicCategory = null;
      this.editingCourseCategory = null;
      this.editingCourseClassGrade = null;
      if (row.Id == 0) {
        this.speedupCourseList.shift();
      }
    },
    handleSelectionChange(val) {
      this.selectedCourses = val;
    },
    deleteSelectedCourse() {
      this.$confirm("您确认到删除所选课程吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          disableSpeedupCourse(this.selectedCourses).then((result) => {
            if (!!result && result.success && result.data) {
              this.loadSpeedupCourseList();
            } else {
              if (result.message) {
                this.$notify.error({
                  title: "删除失败",
                  message: result.message,
                  dangerouslyUseHTMLString: true,
                  duration: 0,
                });
              } else {
                this.$message.error("删除失败");
              }
            }
          });
        })
        .catch(() => {});
    },
  },
  watch: {
    activeUniversityGroup: function () {
      this.loadSpeedupCourseList();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/admin/speedupCourseList.vue